import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '~editor/store'

export const usePluginDescriptors = () => {
  const pluginDescriptors = useSelector(
    ({ pluginDescriptors }: RootState) => pluginDescriptors,
  )
  return useMemo(() => pluginDescriptors?.descriptors, [pluginDescriptors])
}
